enum CumulAddOnServiceVariation {
  SKELETON_KEY_ONLY = "skeletonKeyOnly",
}

export default CumulAddOnServiceVariation;
